import { render } from "./SectionWidget.vue?vue&type=template&id=2193f698&scoped=true"
import script from "./SectionWidget.vue?vue&type=script&lang=js"
export * from "./SectionWidget.vue?vue&type=script&lang=js"

import "./SectionWidget.vue?vue&type=style&index=0&id=2193f698&lang=scss&scoped=true"

import exportComponent from "/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2193f698"]])

export default __exports__